import { render } from "./preliminaire.vue?vue&type=template&id=541dda6d"
import script from "./preliminaire.vue?vue&type=script&lang=js"
export * from "./preliminaire.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__